import { Editor, Extensions } from '@tiptap/core';
import React from 'react';

import { FontOptions, Size } from '@/ui/Editor/extensions';

import { Select } from '../../Select';
import { useTranslation } from 'react-i18next';

interface FontSizeMenuItemProps {
	editor: Editor | null;
}

type TFontSize = {
	label: string;
	value: Size;
	className?: string;
};

const FontSizeMenuItem = (props: FontSizeMenuItemProps) => {
	const { editor } = props;

	const extensions: Extensions = editor?.extensionManager?.extensions ?? [];

	const { t, i18n } = useTranslation();

	const fonts = React.useMemo(() => {
		if (editor) {
			const options = extensions.find((extension) => extension.name === 'font')?.options as FontOptions;
			const fonts = options?.sizes ?? [];

			return fonts.reduce(
				(result, size) => {
					result.push({
						value: size,
						label: `${size}`,
					});

					return result;
				},
				[{ value: 0, label: t('editor.fontSize') }]
			);
		}

		return [];
	}, [editor, i18n.language]);

	if (!editor) {
		return null;
	}

	return (
		<div>
			<Select
				value={fonts.find((size) => editor.getAttributes('textStyle')?.fontSize === size.value) || fonts[0]}
				isSearchable={false}
				defaultValue={fonts[0]}
				options={fonts}
				onChange={({ value }: TFontSize) => {
					if (!value) {
						editor.chain().focus().unsetFontSize().run();

						return;
					}

					editor.chain().focus().setFontSize(value).run();
				}}
			/>
		</div>
	);
};

export { FontSizeMenuItem };
